var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnansweredFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9983_197)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41 6.83333V34.1667C41 37.9353 37.9353 41 34.1667 41H29.0417C28.0987 41 27.3333 40.2347 27.3333 39.2917C27.3333 38.3487 28.0987 37.5833 29.0417 37.5833H34.1667C36.051 37.5833 37.5833 36.051 37.5833 34.1667V6.83333C37.5833 4.94904 36.051 3.41667 34.1667 3.41667H29.0417C28.0987 3.41667 27.3333 2.65133 27.3333 1.70833C27.3333 0.765333 28.0987 0 29.0417 0H34.1667C37.9353 0 41 3.06475 41 6.83333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7658 20.2307C27.7563 19.1833 27.3398 18.1819 26.6066 17.4435L18.1779 8.88265C17.8098 8.51184 17.3118 8.30371 16.7928 8.30371C16.2737 8.30371 15.7757 8.51184 15.4076 8.88265C15.2235 9.06773 15.0773 9.28792 14.9776 9.53053C14.8778 9.77313 14.8265 10.0334 14.8265 10.2962C14.8265 10.559 14.8778 10.8192 14.9776 11.0618C15.0773 11.3044 15.2235 11.5246 15.4076 11.7097L21.8716 18.2398H2.22423C1.70315 18.2398 1.20341 18.4496 0.83495 18.8229C0.46649 19.1963 0.259491 19.7027 0.259491 20.2307C0.259491 20.7587 0.46649 21.2651 0.83495 21.6385C1.20341 22.0118 1.70315 22.2216 2.22423 22.2216H21.8716L15.4076 28.7716C15.0377 29.1438 14.8288 29.6498 14.8269 30.1781C14.8251 30.7064 15.0304 31.2138 15.3978 31.5887C15.7652 31.9636 16.2644 32.1752 16.7858 32.1771C17.3072 32.179 17.8079 31.9709 18.1779 31.5986L26.6066 23.0378C27.3446 22.2945 27.7614 21.285 27.7658 20.2307Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9983_197"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 41,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnansweredFilter);
export default __webpack_public_path__ + "static/media/unanswered-filter.ed7c70a030118f29e52e87b6f1e2fb2d.svg";
export { ForwardRef as ReactComponent };